module.exports = __webpack_public_path__ + "static/media/footer-logo@2x.335e7c71.png";